module.exports = __webpack_public_path__ + "static/images/dynamic.98fda3a27ff8f84415f5c237cd75e0b3.svg";